export default {
  issue: state => state.issue,
  issues: state => state.issues
}



// WEBPACK FOOTER //
// ./src/store/modules/issues/getters.js